import React, { useState } from "react";
import { Slider } from "../../components/slider/Slider";
import recipeImg from "../../assets/images/mock_recipe.svg";
import headerImg from "./../../assets/images/logo-photoshop.svg";
import styles from "./home.module.css";
import { Link } from "react-router-dom";
import NavBar from "../../components/NavBar/NavBar";

const menues =  [
  {
    "menuTitle": "Lasagna de berenjena",
    "menuType": "Vegetariano",
    "time": "45",
    "id": 1,
    "image":"https://www.paulinacocina.net/wp-content/uploads/2022/06/receta-de-lasagna-de-berenjenas.jpg"

    
  },
  {
    "menuTitle": "Fondue de calabaza",
    "menuType": "Salado",
    "time": "85",
    "id": 2,
    "image":"https://radiomitre-la100-prod.cdn.arcpublishing.com/resizer/3y_Hvw-xdg5VCdeRLan6n7In-2M=/1440x0/smart/filters:quality(85):format(webp)/cloudfront-us-east-1.images.arcpublishing.com/radiomitre/3IPBU3LZPJAU5MUHZCKMUYLZ7E.jpg"
  },
  {
    "menuTitle": "Asado",
    "menuType": "Vegetariano",
    "time": "45",
    "id": 3,
    "image":"https://t1.rg.ltmcdn.com/es/posts/4/1/7/anticuchos_vegetarianos_74714_orig.jpg"

  },
  {
    "menuTitle": "Nuggets de pollo",
    "menuType": "Salado",
    "time": "45",
    "id": 4,
    "image":"https://www.divinacocina.es/wp-content/uploads/2018/08/nuggets-de-pollo-caseros-3.jpg"

  },
  {
    "menuTitle": "Hamburguesas veganas",
    "menuType": "Sin TACC",
    "time": "120",
    "id": 5,
    "image":"https://radiomitre-la100-prod.cdn.arcpublishing.com/resizer/3y_Hvw-xdg5VCdeRLan6n7In-2M=/1440x0/smart/filters:quality(85):format(webp)/cloudfront-us-east-1.images.arcpublishing.com/radiomitre/3IPBU3LZPJAU5MUHZCKMUYLZ7E.jpg"

  },
  {
    "menuTitle": "Tarta",
    "menuType": "Vegetariano",
    "time": "43",
    "id": 6,
    "image":"https://www.ilolay.com.ar/uploads/recetas/1633199442-Tarta-de-verduras-grilladas-con-Queso-Untable-Por-Salut-Light.jpg"

  },
  {
    "menuTitle": "Fondue de calabaza",
    "menuType": "Salado",
    "time": "85",
    "id": 7,
    "image":"https://radiomitre-la100-prod.cdn.arcpublishing.com/resizer/3y_Hvw-xdg5VCdeRLan6n7In-2M=/1440x0/smart/filters:quality(85):format(webp)/cloudfront-us-east-1.images.arcpublishing.com/radiomitre/3IPBU3LZPJAU5MUHZCKMUYLZ7E.jpg"

  },
  {
    "menuTitle": "Empanadas",
    "menuType": "Vegetariano",
    "time": "55",
    "id": 8,
    "image":"https://assets.unileversolutions.com/recipes-v2/239857.jpg?imwidth=900"

  },
  {
    "menuTitle": "Tortilla",
    "menuType": "Salado",
    "time": "63",
    "id": 9,
    "image":"https://assets.unileversolutions.com/recipes-v2/37805.jpg?imwidth=900"

  },
  {
    "menuTitle": "fideos",
    "menuType": "Sin TACC",
    "time": "120",
    "id": 10,
    "image":"https://radiomitre-la100-prod.cdn.arcpublishing.com/resizer/3y_Hvw-xdg5VCdeRLan6n7In-2M=/1440x0/smart/filters:quality(85):format(webp)/cloudfront-us-east-1.images.arcpublishing.com/radiomitre/3IPBU3LZPJAU5MUHZCKMUYLZ7E.jpg"

  }
]



const {
  container,
  header,
  link,
  title,
  subTitle,
  h3,
  section_container,
  recipe_day,
  img_header,
} = styles;

export const Home = ({ stateSwipe, loadingSwipe, logged }) => {
  // const [user, setUser] = useState(null);

  return (
    <>
      <NavBar logged={logged}></NavBar>
      <main className={container}>
        <h1 className={title}>Matcheá con tu próxima comida</h1>
        <h2 className={subTitle}>
          ¿No sabés qué cocinar hoy? Nosotros te ayudamos a encontrar tu próxima
          receta. {";)"}
        </h2>
        <section className={header}>
          <picture>
            <img src={headerImg} alt="match-menu" className={img_header} />
          </picture>

          <Link to={"swipe"} className={link}>
            ¡Probalo acá!
          </Link>
        </section>

        <section className={section_container}>
          <h3 className={h3}>Mejores Valoradas</h3>
          <Slider data={menues.slice(3)} />
        </section>

        <section className={section_container}>
          <h3 className={h3}>Descubrí nuevas recetas</h3>
          <Slider data={menues} />
        </section>

        <section className={section_container}>
          <h3 className={h3}>Receta del día</h3>
          <article className={recipe_day}>
            <img src={recipeImg} alt="recipe-img" />
          </article>
        </section>
      </main>
    </>
  );
};
